import React from 'react';
import {
  openWhatsApp,
  DASH_CS_WHATSAPP_NUMBER,
  formatWhatsAppNumber,
} from '@/utils/whatsapp';

// Consumer-complaint footer (Kemendag-compliant), mirroring the prototype's
// `.gov-footer`. Dark surface using DS tokens (no raw hex). The Dash CS
// WhatsApp number comes from env and opens a plain chat (no pre-filled text).
const SignInFooter: React.FC = () => {
  const waDisplay = formatWhatsAppNumber(DASH_CS_WHATSAPP_NUMBER);

  return (
    <footer className="flex flex-wrap gap-x-14 gap-y-4 bg-bg-strong-950 px-6 py-5 text-static-white sm:px-10">
      <div className="min-w-[200px] flex-1">
        <div className="text-sm font-semibold">Layanan Pengaduan Konsumen</div>
        <div className="text-xs text-static-white/60">
          PT Dash Platform Indonesia
        </div>
      </div>

      <div className="min-w-[200px] flex-1 space-y-1">
        <div className="text-xs leading-relaxed text-static-white/80">
          Email:{' '}
          <a
            href="mailto:info@dashelectric.co"
            className="font-medium text-static-white underline-offset-2 hover:underline"
          >
            info@dashelectric.co
          </a>
        </div>
        {waDisplay && (
          <div className="text-xs leading-relaxed text-static-white/80">
            Whatsapp:{' '}
            <button
              type="button"
              onClick={() => openWhatsApp()}
              className="font-medium text-static-white underline-offset-2 hover:underline"
            >
              {waDisplay}
            </button>
          </div>
        )}
      </div>

      <div className="min-w-[200px] flex-1 space-y-1">
        <div className="text-xs leading-relaxed text-static-white/80">
          Kementerian Perdagangan Republik Indonesia
        </div>
        <div className="text-xs leading-relaxed text-static-white/80">
          Whatsapp: +62 853-1111-1010
        </div>
      </div>

      <div className="min-w-[200px] flex-1">
        <div className="text-xs leading-relaxed text-static-white/80">
          Direktorat Jenderal Perlindungan Konsumen dan Tertib Niaga
        </div>
      </div>
    </footer>
  );
};

export default SignInFooter;
